

















































































































import { Component, Vue } from 'vue-property-decorator';
import * as cookies from 'js-cookie';

const cookieId: string = 'mp_cookies_industrydashboard_accepted';

@Component
export default class MpCookieBanner extends Vue {
  cookiesAccepted: boolean = false;
  cookieBannerInitialLoadDelayDone: boolean = false;

  created() {
    if (cookies.get(cookieId) === '1') {
      this.cookiesAccepted = true;
    }
  }

  mounted() {
    setTimeout(() => {
      this.cookieBannerInitialLoadDelayDone = true;
    }, 600);
  }

  openUrl(url: string, target: string) {
    window.open(url, target);
  }

  async acceptCookies() {
    const now = new Date();

    cookies.set(cookieId, '1', {
      expires: new Date(now.getFullYear() + 1, now.getMonth(), now.getDate())
    });
    this.cookiesAccepted = true;
  }
}
